module.exports = __webpack_public_path__ + "img/img02.66d605c3.png";